import * as types from '../types';
import {configImage, productImageUrl} from '../../api'

import Vue from 'vue';

const state = {
    products: [],
    bestsellers: [],
    product_options_values: []
};

const _PRODUCT_CONTROLLER_URL = 'index.php?controller=product&id_product=';

const getters = {
    /**
     *
     * @param state
     * @returns {Array|*|{mutations, state, getters, actions}|default.computed.products|state.products|{}}
     */
    [types.GET_PRODUCTS]: state => {
        return state.products;
    },
    /**
     *
     * @param state
     * @returns {function(*): T}
     */
    [types.GET_PRODUCT]: (state) => (id) => {
        return state.products.find((item) => item.id === id);
    },
    /**
     *
     * @param state
     * @returns {function(*, *): string}
     */
    [types.GET_URL_PRODUCT]: (state) => (idProduct, hostname) => {
        return hostname + _PRODUCT_CONTROLLER_URL + idProduct;
    }
};


const actions = {
    /**
     *
     * @param commit
     * @param url
     * @param config
     */
    [types.LOAD_PRODUCT]: ({commit, dispatch}, {url, config, addResult}) => {
        Vue.http.get(url, config)
            .then(response => {
                return response.json();
            })
            .then(response => {
                const {product} = response;
                const {id_default_image, id} = product;
                if (id_default_image) {
                    Vue.http.get(productImageUrl(id, id_default_image), configImage)
                        .then(response => {
                            return response.blob();
                        })
                        .then(blob => {
                            product.imageDefault = URL.createObjectURL(blob);
                            commit(types.MUTATE_ADD_PRODUCT, {product});
                            if (addResult) {
                                dispatch(types.ADD_PRODUCT_RESULT, product);
                            }
                        });
                }
            });
    },

    /**
     * TODO: Refacto
     * @param commit
     * @param dispatch
     * @param url
     * @param config
     * @param addResult
     */
    [types.LOAD_BESTSELLER]: ({commit, dispatch}, {url, config, addResult}) => {
        Vue.http.get(url, config)
            .then(response => {
                return response.json();
            })
            .then(response => {
                const {product} = response;
                const {id_default_image, id} = product;
                if (id_default_image) {
                    Vue.http.get(productImageUrl(id, id_default_image), configImage)
                        .then(response => {
                            return response.blob();
                        })
                        .then(blob => {
                            product.imageDefault = URL.createObjectURL(blob);
                            commit(types.MUTATE_ADD_BESTSELLER, {product});
                            if (addResult) {
                                dispatch(types.ADD_BESTSELLER_RESULT, product);
                            }
                        });
                }
            });
    },
};

const mutations = {
    /**
     *
     * @param state
     * @param product
     */
    [types.MUTATE_ADD_PRODUCT]: (state, {product}) => {
        state.products.push(product);
    },
    /**
     *
     * @param state
     * @param product
     */
    [types.MUTATE_ADD_BESTSELLER]: (state, {product}) => {
        state.bestsellers.push(product);
    },
    /**
     *
     * @param state
     * @param combination
     * @param product
     */
    [types.MUTATE_ADD_COMBINATION]: (state, {combination, product}) => {
        product.combinations.push(combination);
    },
    /**
     *
     * @param state
     * @param options
     */
    [types.MUTATE_ADD_PRODUCT_OPTION_VALUE]: (state, options) => {
        state.product_options_values.push(options);
    }

}

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/products.js